import { useEffect, useMemo, useState } from 'react';
import { getSearchKey, useAppSelector } from '@zonofi/zono-money-store';
import { debounce } from 'lodash';

export const useDebounceSearch = () => {
  const searchKey = useAppSelector(getSearchKey);
  const [debouncedSearchValue, setDebouncedSearchValue] = useState<string>('');

  const debouncedSearch = useMemo(
    () =>
      debounce((value: string) => {
        setDebouncedSearchValue(value);
      }, 500),
    []
  );

  useEffect(() => {
    debouncedSearch(searchKey);
    return () => {
      debouncedSearch.cancel();
    };
  }, [searchKey, debouncedSearch]);

  return { debouncedSearchValue };
};
